"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIconTextColor = exports.usePillStyles = void 0;
const malty_atoms_icon_wrapper_1 = require("@carlsberggroup/malty.atoms.icon-wrapper");
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const Pill_types_1 = require("./Pill.types");
const usePillStyles = ({ size }) => {
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    const pillStyles = {
        [Pill_types_1.PillSize.ExtraSmall]: {
            numSize: theme.sizes.s.value,
            fontSize: theme.typography.desktop.text.micro_bold['font-size'].value,
            fontFamily: theme.typography.desktop.text.micro_bold['font-family'].value,
            iconSize: theme.sizes.xs.value,
            padding: theme.sizes['3xs'].value,
            marginText: theme.sizes['5xs'].value
        },
        [Pill_types_1.PillSize.Small]: {
            numSize: theme.sizes.m.value,
            fontSize: theme.typography.desktop.text.tiny_bold['font-size'].value,
            fontFamily: theme.typography.desktop.text.tiny_bold['font-family'].value,
            iconSize: theme.sizes.s.value,
            padding: theme.sizes.xs.value,
            marginText: theme.sizes['4xs'].value
        },
        [Pill_types_1.PillSize.Medium]: {
            numSize: theme.sizes.l.value,
            fontSize: theme.typography.desktop.text['medium-small_bold']['font-size'].value,
            fontFamily: theme.typography.desktop.text['medium-small_bold']['font-family'].value,
            iconSize: theme.sizes.m.value,
            padding: theme.sizes.s.value,
            marginText: theme.sizes['4xs'].value
        }
    };
    return pillStyles[size];
};
exports.usePillStyles = usePillStyles;
const useIconTextColor = ({ color }) => {
    if (color === Pill_types_1.PillColor.Archive || color === Pill_types_1.PillColor.Success || color === Pill_types_1.PillColor.alertStrong) {
        return malty_atoms_icon_wrapper_1.IconColor.DigitalBlack;
    }
    return malty_atoms_icon_wrapper_1.IconColor.White;
};
exports.useIconTextColor = useIconTextColor;
//# sourceMappingURL=Pill.helper.js.map